// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"eccfa1be","488":"ecbfdacb"}[chunkId] + ".chunk.js";
};